module.exports = __webpack_public_path__ + "img/海量优质数据-中层.7d0b85c1.png";